import React, { useEffect, useState } from "react"
import { createPortal } from "react-dom"

import StickyContainer, {
  STICKY_PORTAL_ID,
} from "../../../elements/V2/StickyContainer"

const ScrollLinksBannerMobileWrapper = ({
  children,
  isVisible,
}: {
  children: React.ReactNode
  isVisible: boolean
}) => {
  const [isMounted, setIsMounted] = useState(false)
  const [stickyPortalElement, setStickyPortalElement] =
    useState<HTMLElement | null>(null)

  useEffect(() => {
    setIsMounted(true)
    setStickyPortalElement(
      document.getElementById(STICKY_PORTAL_ID) as HTMLElement
    )
  }, [])

  if (!isMounted) {
    return null
  }

  if (stickyPortalElement) {
    return createPortal(children, stickyPortalElement)
  }

  return createPortal(
    <StickyContainer isVisible={isVisible} noPadding>
      {children}
    </StickyContainer>,
    document.body
  )
}

export default ScrollLinksBannerMobileWrapper
